import { auth } from "../config/firebase";

export function getUser() {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
}

export function getToken() {
  // For backward compatibility, check if user has old-style token
  const user = getUser();
  return user?.token || null;
}

export function isTokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
}

export function isAuthenticated() {
  // Check Firebase authentication state first
  if (auth.currentUser) {
    return true;
  }
  
  // Fallback: Check localStorage for backward compatibility during transition
  const user = localStorage.getItem("user");
  
  if (!user) return false;
  
  try {
    const userData = JSON.parse(user);
    
    // Check if essential user data is present
    if (userData.id || userData.spId || userData.phone || userData.email) {
      return true;
    }
    
    return false;
  } catch {
    return false;
  }
}

/**
 * Logout user - clears session, signs out from Firebase, and stops token refresh
 */
export async function logout() {
  try {
    // Import stopTokenRefresh dynamically to avoid circular dependency
    const { stopTokenRefresh } = await import('../../utils/auth');
    
    // Stop token refresh timer
    stopTokenRefresh();
    
    // Sign out from Firebase
    await auth.signOut();
    
    // Clear local storage
    localStorage.removeItem("user");
    localStorage.clear();
    sessionStorage.clear();
    
    console.log('User logged out successfully');
  } catch (error) {
    console.error('Error during logout:', error);
    // Still clear local data even if Firebase signOut fails
    localStorage.removeItem("user");
    localStorage.clear();
    sessionStorage.clear();
  }
}